import { render, staticRenderFns } from "./VueSlickCarousel.vue?vue&type=template&id=014a15b2"
import script from "./VueSlickCarousel.vue?vue&type=script&lang=js"
export * from "./VueSlickCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports